import { useContext, useEffect, useState } from "react";

import ListPage from "../../../shared/components/list-page/list-page";
import { IColumn } from "../../../shared/components/normal-table/normal-table";
import Spinner from "../../../shared/components/spinner/spinner";
import { roleWrite, roleAdmin } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData, IListPageData } from "../../../shared/utils/api";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";

import "./report_logs.scss";
import { useParams } from "react-router";

export const resultsColumns: IColumn[] = [
  {
    key: "date",
    displayName: "Date",
    dataType: {
      type: "text",
    },
    noWrap: true
  },
  {
    key: "comment",
    displayName: "Note",
    dataType: {
      type: "text",
    },
  },
  {
    key: "state_update",
    displayName: "State update",
    dataType: {
      type: "text",
    },
    noWrap: true
  },
  {
    key: "user_info",
    displayName: "User name",
    dataType: {
      type: "text",
    },
    noWrap: true
  },
];

const ReportLogs = () => {
  const [reportsData, setReportsData] = useState<IListPageData | undefined>({rows: []});
  const [unblockInput, setUnblockInput] = useState(false);
  const [sortedBy, setSortedBy] = useState("?order_by=date asc");
  const [currentOffset, setCurrentOffset] = useState(1);
  const authCtx = useContext(AuthContext);

  const { sendRequest: getSortBy, status: getSortByStatus, data: getSortByData, error: errorGetSortByData } = useHttp(getAllData, false, authCtx.token, undefined, "analytics");
  const { sendRequest: getSortByPagination, status: getSortByPaginationStatus, data: getSortByPaginationData, error: getSortByPaginationError } = useHttp(getAllData, false, authCtx.token, undefined, "analytics");

  const params = useParams();

  useEffect(() => {
    getSortBy(`report/logs/${params.id}`, "?order_by=date desc&limit=50&offset=0");
  }, []);

  const onTableScrollAction = (offset: number) => {
    if (reportsData && reportsData.rows.length >= 50) {
      setCurrentOffset(offset);
      if (!getSortByPaginationData) {
        getSortByPagination(`report/logs/${params.id}`, `${sortedBy}&limit=50&offset=${offset * 50}`);
      } else if (getSortByPaginationData.rows.length !== 0) {
        getSortByPagination(`report/logs/${params.id}`, `${sortedBy}&limit=50&offset=${offset * 50}`);
      }
    }
  };

  useEffect(() => {
    if (getSortByPaginationStatus === "completed" && !getSortByPaginationError) {
      reportsData && setReportsData({rows: [...reportsData.rows, ...getSortByPaginationData.rows]});
    }
  }, [getSortByPaginationStatus]);

  useEffect(() => {
    if (getSortByStatus === "completed" && !errorGetSortByData) {
      setReportsData(getSortByData);
    }
  }, [getSortByStatus]);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleAdmin) !== -1) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  const sortBy = (sortingQuery: string) => {
    getSortBy(`report/logs/${params.id}`, `${sortingQuery}&limit=${currentOffset * 50}&offset=0`);
    setSortedBy(sortingQuery);
  };

  return (
    <div className="reportList">
      {validateLoadingStatusNew([getSortByStatus, getSortByPaginationStatus]) && <Spinner />}
      {
        <ListPage
          title={"Audit logs"}
          sortBy={sortBy}
          defaultSortCol={"date"}
          onTableScrollAction={onTableScrollAction}
          tooltipTxt={"Audit log of all the changes in the state of the report"}
          columns={resultsColumns}
          unblockInput={unblockInput}
          dataUrl={"reports/:id"}
          pageMode={"nonEditable"}
          fetchedData={reportsData}
          allStatus={"completed"}
          hideCheckBoxes={true}
          hideButtons={["add", "delete"]}
        />
      }
    </div>
  );
};

export default ReportLogs;
